<template>
  <div class="block block-cust">
    <div class="container">
      <div class="title title-cust">如何做好合同的“四好”管理</div>
      <div class="entitle entitle-cust">
        How to do well the "four good" management of contract
      </div>

      <div v-if="isMobile">
        <div>
          <div class="box">
            <img :src="p6" alt="" />
            <div>
              <div class="box-t">“签好”合同</div>
              <div class="box-c">
                公司所有的合同都经由指定的业务IT系统，实现规范化的签署，来保障签约的安全。
              </div>
            </div>
          </div>
          <div class="box">
            <img :src="p7" alt="" />
            <div>
              <div class="box-t">签“好合同”</div>
              <div class="box-c">
                “好合同”主要指合同内容的质量，根据企业业务场景建立合同范本库、条款库和风险指引。
              </div>
            </div>
          </div>
          <div class="box">
            <img :src="p8" alt="" />
            <div>
              <div class="box-t">“好签”合同</div>
              <div class="box-c">
                通过优化流程和IT工具提高合同评审效率、决策质量，促进业务便利和高效。
              </div>
            </div>
          </div>
          <div class="box">
            <img :src="p9" alt="" />
            <div>
              <div class="box-t">“履好”合同</div>
              <div class="box-c">
                合同签订之后并不代表合同管理流程的结束，要重视合同履约、管控验收和结算。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="wrap">
        <div class="wrap-left animated" v-animate="'slideInLeft'">
          <div class="box">
            <div>
              <div class="box-t">“签好”合同</div>
              <div class="box-c">
                公司所有的合同都经由指定的业务IT系统，实现规范化的签署，来保障签约的安全。
              </div>
            </div>
            <img :src="p6" alt="" />
          </div>
          <div class="box">
            <div>
              <div class="box-t">签“好合同”</div>
              <div class="box-c">
                “好合同”主要指合同内容的质量，根据企业业务场景建立合同范本库、条款库和风险指引。
              </div>
            </div>
            <img :src="p7" alt="" />
          </div>
        </div>
        <div class="wrap-center">
          <img :src="p10" alt="" />
        </div>
        <div class="wrap-right animated" v-animate="'slideInRight'">
          <div class="box">
            <img :src="p8" alt="" />
            <div>
              <div class="box-t">“好签”合同</div>
              <div class="box-c">
                通过优化流程和IT工具提高合同评审效率、决策质量，促进业务便利和高效。
              </div>
            </div>
          </div>
          <div class="box">
            <img :src="p9" alt="" />
            <div>
              <div class="box-t">“履好”合同</div>
              <div class="box-c">
                合同签订之后并不代表合同管理流程的结束，要重视合同履约、管控验收和结算。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p6 from "@/assets/images/home/p6.png";
import p7 from "@/assets/images/home/p7.png";
import p8 from "@/assets/images/home/p8.png";
import p9 from "@/assets/images/home/p9.png";
import p10 from "@/assets/images/home/p10.png";
export default {
  data() {
    return {
      p6,
      p7,
      p8,
      p9,
      p10,
    };
  },
};
</script>

<style scoped>
.block-cust {
  background: #2f56ce;
}
.title-cust {
  color: #fff;
}
.entitle-cust {
  color: #fff;
}

.wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.wrap-center {
  margin: 0 40px;
  margin-top: -20px;
}
.box {
  display: flex;
  align-items: center;
  color: #fff;
  padding-bottom: 80px;
}
.box-t {
  font-size: 24px;
}
.box-c {
  font-size: 15px;
  color: #f3f8fe;
}
.wrap-left {
  text-align: right;
}
.wrap-left img {
  margin-left: 20px;
  width: 70px;
  height: 70px;
}
.wrap-right img {
  margin-right: 20px;
  width: 70px;
  height: 70px;
}

/*  */
.mb .block-cust {
  background: #fff;
}
.mb .title-cust {
  color: #3975ea;
}
.mb .entitle-cust {
  color: #b3b3b3;
}

.mb .box {
  padding: 0;
  margin: 40px 0;
}
.mb .box img {
  width: 54px;
  min-width: 54px;
  height: 54px;
  margin-right: 20px;
}
.mb .box-t {
  font-size: 17px;
  color: #2f56ce;
}
.mb .box-c {
  font-size: 13px;
  color: #888;
}
</style>